import React, { Fragment, useRef, useState } from "react";
import { useEffectOnce } from "../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import {
  setProcessing,
  setPageValue,
  loadPage,
  setPanes,
  filterPage,
  moveFirst,
  movePrevious,
  moveNext,
  moveLast,
  markedAsRead,
  markAsUnread,
  removeUserNotification,
  loadEntity,
  removeEntityFromUI,
  setFormValue,
  disposePage,
  markAsRead,
  removeUserNotifications,
} from "../../redux/slices/notificationspageslice";
import { addNotification } from "../../redux/slices/notificationsslice";
import { notificationDurationMiddle } from "../../lib/utils";
import { hideAppDialog, setAppDialog } from "../../redux/slices/appdialogslice";
import { useNavigate, useLocation } from "react-router-dom";
import { apiErrorsHandler, getErrorMessages } from "../../api/httpclient";
import { Page } from "../page";
import { NotificationsPageBody } from "./notificationspagebody";

import i18next from "i18next";
import { useTranslation } from "react-i18next";


export const NotificationsPage = (props) => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.notificationsPage);
  const navigate = useNavigate();

  const [typeId, setTypeId] = useState(0);
  const [title, setTitle] = useState("");
  const [importance, setImportance] = useState(0);
  const { t } = useTranslation();

  /*initial page load*/
  useEffectOnce(() => {
    dispatch(loadPage(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("notifications.loading_errormessage"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              })
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              })
            );
          }

          //go home
          navigate("/", { replace: true });
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("notifications.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
          navigate("/", { replace: true });
        };

        apiErrorsHandler({}, dispatch, navigate, err, "/", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );

    return () => {
      dispatch(disposePage(true));
    };
  }, []);
  /*initial load*/

  /*splitter*/
  const handleOnSplitterChange = (e) => {
    dispatch(setPanes(e.newState));
  };
  /*splitter*/

  /*onFilter*/
  const handleOnFilter = (
    filterTypeId = typeId,
    filterTitle = title,
    filterImportance = importance,
  ) => {
    dispatch(filterPage(filterTypeId, filterTitle, filterImportance, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };
  /*onFilter*/

  const handleOnMobileTypeChange = (value) => {
    setTypeId(value);
    setTitle("");
    setImportance(0);
    handleOnFilter(value, "", 0);
  };

  /*navigation*/
  const handleOnMoveFirst = (e) => {
    dispatch(moveFirst(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };

  const handleOnMovePrevious = (e) => {
    dispatch(movePrevious(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };

  const handleOnMoveNext = (e) => {
    dispatch(moveNext(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };

  const handleOnMoveLast = (e) => {
    dispatch(moveLast(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };
  /*navigation*/

  /*actions*/
  const handleOnMarkAsRead = (id) => {
    dispatch(markAsRead(id, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };

  const handleOnMarkAsUnread = (id) => {
    dispatch(markAsUnread(id, t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else errorMessages = getErrorMessages(errorMessages, 1);

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };

  const handleOnRemove = (id) => {
    dispatch(
      setAppDialog({
        isVisible: true,
        className: "notifications-page-are-you-sure",
        title: t("notifications.warning"),
        content:
          t("notifications.areyousure"),
        actions: {
          yesButton: {
            title: t("notifications.yes"),
            handler: () => {
              dispatch(hideAppDialog());

              dispatch(removeUserNotification(id, t)).then(
                (response) => {},
                (err) => {
                  dispatch(setProcessing({ processing: false }));

                  const handleResponseReceived = (
                    state,
                    dispatch,
                    navigate,
                    payload
                  ) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                      errorMessages = [t("notifications.unknown_error")];
                    else {
                      errorMessages = getErrorMessages(errorMessages, 1);

                      if (payload.data.ErrorCodes.EntityDoesNotExist)
                        dispatch(removeEntityFromUI(id));
                    }

                    dispatch(
                      addNotification({
                        text: errorMessages[0],
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      })
                    );
                  };

                  const handleUnhandled = (
                    state,
                    dispatch,
                    navigate,
                    payload
                  ) => {
                    let errorMessage = t("notifications.unknown_error");
                    dispatch(
                      addNotification({
                        text: errorMessage,
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      })
                    );
                  };

                  apiErrorsHandler({}, dispatch, navigate, err, null, {
                    responseReceived: handleResponseReceived,
                    unhandled: handleUnhandled,
                  });
                }
              );
            },
          },
          noButton: { title: t("notifications.no") },
        },
      })
    );
  };

  const handleOnClose = () => {
    dispatch(setPageValue({ id: "formValues", value: {} }));
  };

  const handleOnRemoveNotifications = (type, title, importance) => {
    dispatch(
      setAppDialog({
        isVisible: true,
        className: "notifications-page-are-you-sure",
        title: t("notifications.warning"),
        content: t("notifications.areyousure1"),
        actions: {
          yesButton: {
            title: t("notifications.yes"),
            handler: () => {
              dispatch(hideAppDialog());

              dispatch(removeUserNotifications(type, title, importance, t)).then(
                (response) => {
                  dispatch(
                    addNotification({
                      text: t("notifications.deletesuccess"),
                      type: "success",
                      closable: true,
                      duration: notificationDurationMiddle,
                      position: "topRight",
                    })
                  );
                  dispatch(loadPage(t)).then(
                    (response) => {},
                    (err) => {
                      //hide loader
                      dispatch(setProcessing({ processing: false }));

                      const handleResponseReceived = (
                        state,
                        dispatch,
                        navigate,
                        payload
                      ) => {
                        let errorMessages = payload?.data?.ErrorMessages;

                        //notify with error
                        if (!errorMessages || errorMessages.length == 0)
                          dispatch(
                            addNotification({
                              text: t("notifications.loading_errormessage"),
                              type: "error",
                              closable: true,
                              duration: notificationDurationMiddle,
                              position: "topRight",
                            })
                          );
                        else {
                          errorMessages = getErrorMessages(errorMessages, 1);
                          dispatch(
                            addNotification({
                              text: errorMessages[0],
                              type: "error",
                              closable: true,
                              duration: notificationDurationMiddle,
                              position: "topRight",
                            })
                          );
                        }

                        //go home
                        navigate("/", { replace: true });
                      };

                      const handleUnhandled = (
                        state,
                        dispatch,
                        navigate,
                        payload
                      ) => {
                        dispatch(
                          addNotification({
                            text: t("notifications.unknown_error"),
                            type: "error",
                            closable: true,
                            duration: notificationDurationMiddle,
                            position: "topRight",
                          })
                        );
                        navigate("/", { replace: true });
                      };

                      apiErrorsHandler({}, dispatch, navigate, err, "/", {
                        responseReceived: handleResponseReceived,
                        unhandled: handleUnhandled,
                      });
                    }
                  );
                },
                (err) => {
                  dispatch(setProcessing({ processing: false }));

                  const handleResponseReceived = (
                    state,
                    dispatch,
                    navigate,
                    payload
                  ) => {
                    let errorMessages = payload?.data?.ErrorMessages;

                    if (!errorMessages || errorMessages.length == 0)
                      errorMessages = [t("notifications.unknown_error")];
                    else {
                      errorMessages = getErrorMessages(errorMessages, 1);

                      //if (payload.data.ErrorCodes.EntityDoesNotExist)
                      //dispatch(removeEntityFromUI(id));
                    }

                    dispatch(
                      addNotification({
                        text: errorMessages[0],
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      })
                    );
                  };

                  const handleUnhandled = (
                    state,
                    dispatch,
                    navigate,
                    payload
                  ) => {
                    let errorMessage = t("notifications.unknown_error");
                    dispatch(
                      addNotification({
                        text: errorMessage,
                        type: "error",
                        closable: true,
                        duration: notificationDurationMiddle,
                        position: "topRight",
                      })
                    );
                  };

                  apiErrorsHandler({}, dispatch, navigate, err, null, {
                    responseReceived: handleResponseReceived,
                    unhandled: handleUnhandled,
                  });
                }
              );
            },
          },
          noButton: { title: t("notifications.no") },
        },
      })
    );
  };
  /*actions*/

  /*loading*/
  const handleOnEntitySelected = (entityId, item) => {
    dispatch(loadEntity(entityId, t)).then(
      (response) => {},
      (err) => {
        //hid eloader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("notifications.unknown_error")];
          else {
            errorMessages = getErrorMessages(errorMessages, 1);

            if (payload.data.ErrorCodes.EntityDoesNotExist)
              dispatch(removeEntityFromUI(entityId));
          }

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("notifications.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };
  /*loading*/

  //tools visible/hidden
  const handleOnToolsToggle = (e) => {
    const isVisible = pageState.toolsVisible;

    if (isVisible)
      //hide
      dispatch(
        setPanes([
          {
            //size: "30%",
            size: "0%",
            min: "%",
            max: "%",
            collapsible: false,
          },
          {
            min: "100%",
            collapsible: false,
          },
        ])
      );
    else
      dispatch(
        setPanes([
          {
            //size: "30%",
            size: "20%",
            min: "20%",
            max: "20%",
            collapsible: false,
          },
          {
            min: "80%",
            collapsible: false,
          },
        ])
      );

    dispatch(setPageValue({ id: "toolsVisible", value: !isVisible }));
    //dispatch(redrawTiles());
  };

  const handleOnManageAlert = (e) => {
    navigate("/alerts", { replace: true });
  };

  const handleOnCloseNotfication = (e) => {
    navigate("/", { replace: true });
  };
  

  return (
    <Fragment>
      <Page
        id="notificationsPage"
        className="notifications-page"
        title={t("notifications.notifications")}
        animation={props.animation}
      >
        <NotificationsPageBody
          typeId={typeId}
          title={title}
          importance={importance}
          onTypeIdChange={(value) => setTypeId(value)}
          onMobileTypeChange={handleOnMobileTypeChange}
          onTitleChange={(value) => setTitle(value)}
          onImportanceChange={(value) => setImportance(value)}
          onSplitterChange={handleOnSplitterChange}
          onRemoveNotifications={(type, title, importance) =>
            handleOnRemoveNotifications(type, title, importance)
          }
          onFilter={handleOnFilter}
          onMoveFirst={handleOnMoveFirst}
          onMovePrevious={handleOnMovePrevious}
          onMoveNext={handleOnMoveNext}
          onMoveLast={handleOnMoveLast}
          onMarkAsRead={(id) => handleOnMarkAsRead(id)}
          onMarkAsUnread={(id) => handleOnMarkAsUnread(id)}
          onRemove={(id) => handleOnRemove(id)}
          onEntitySelected={handleOnEntitySelected}
          onClose={handleOnClose}
          onToolsToggle={handleOnToolsToggle}
          onManageAlert={handleOnManageAlert}
          onCloseNotfication={handleOnCloseNotfication}
        />
      </Page>
      <style>
        {`
                    /*page class*/
                    .notifications-page
                    {
                        background-color: transparent;
                        padding: ${currentTheme.pagePadding};
                    }

                    .notifications-page .k-splitbar.k-splitbar-horizontal
                    {
                        background-color: ${currentTheme.paneSeparatorBg};
                    }

                    .notifications-page .k-splitbar
                    {
                        width: ${currentTheme.paneSeparatorWidth};
                    }

                    /*are you sure to delete*/
                    .notifications-page-are-you-sure .k-widget
                    {
                      /*width of the dialog*/
                      width: 300px;
                    }    
                    
                    .notifications-page-are-you-sure .k-widget .k-dialog-titlebar.k-header.k-header
                    {
                        /*bg color of the header*/
                        background-color: ${currentTheme.primary};
                    }
                    `}
      </style>
    </Fragment>
  );
};

//export const NotificationsPage = {Component: Notifications};
